import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { Redirect } from 'react-router'

import { isLoggedIn } from "utils";


export default (WrappedComponent) => {
  class withAuth extends React.Component {

    render() {
      return !isLoggedIn() ?
        (
          <Redirect to={'/'}/>
        ) :
        (
          <WrappedComponent {...this.props} />
        );
    }
  }

  hoistNonReactStatic(withAuth, WrappedComponent);

  return withAuth;
}